export default __webpack_public_path__ + "4ee2f30ef86dcb29784040a00ffc6e86.svg";